import { render, staticRenderFns } from "./trade.vue?vue&type=template&id=00ba2dba&"
import script from "./trade.vue?vue&type=script&lang=js&"
export * from "./trade.vue?vue&type=script&lang=js&"
import style0 from "./trade.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports